import { useEffect } from "react";

/** Loads GTM when REACT_APP_GTM_CONTAINER_ID is set (e.g. GTM-XXXXXX). */
const TagManager = () => {
    useEffect(() => {
        const id = process.env.REACT_APP_GTM_CONTAINER_ID?.trim();
        if (!id || typeof window === "undefined" || window.__lnGtmInjected) {
            return;
        }
        window.__lnGtmInjected = true;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "gtm.start": Date.now(),
            event: "gtm.js"
        });

        const script = document.createElement("script");
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
        document.head.appendChild(script);
    }, []);

    const id = process.env.REACT_APP_GTM_CONTAINER_ID?.trim();
    if (!id) {
        return null;
    }

    return (
        <noscript>
            <iframe
                title="Google Tag Manager"
                src={`https://www.googletagmanager.com/ns.html?id=${id}`}
                height="0"
                width="0"
                style={{ display: "none", visibility: "hidden" }}
            />
        </noscript>
    );
};

export default TagManager;
